import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Aperture, Calendar, Camera, FocalLength, Iso, Timer } from "@air/next-icons";
import { MONTH_DAY_YEAR_FORMAT } from "@air/utilities";
import { memo } from "react";
import { InfoPanelCameraDetailsItem } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelCameraDetails/components/InfoPanelCameraDetailsItem";
import { getCameraSectionTitle } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelCameraDetails/utils/getCameraSectionTitle";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailTitle } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/IntoPanelDetailTitle";
import { formatMetadataDate, isNumberMetadataType, isStringMetadataType } from "~/utils/iptcDataTypes";
export const InfoPanelCameraDetails = /*#__PURE__*/ memo((param)=>{
    let { clipMetadata } = param;
    const cameraMake = clipMetadata.find((metadata)=>metadata.fieldName === "Make");
    const cameraModel = clipMetadata.find((metadata)=>metadata.fieldName === "Model");
    const iso = clipMetadata.find((metadata)=>metadata.fieldName === "ISO");
    const aperture = clipMetadata.find((metadata)=>metadata.fieldName === "FNumber");
    const exposureTime = clipMetadata.find((metadata)=>metadata.fieldName === "ExposureTime");
    const focalLength = clipMetadata.find((metadata)=>metadata.fieldName === "FocalLength");
    const dateTaken = clipMetadata.find((metadata)=>metadata.fieldName === "DateTimeOriginal");
    if (!(cameraMake === null || cameraMake === void 0 ? void 0 : cameraMake.data) && !(cameraModel === null || cameraModel === void 0 ? void 0 : cameraModel.data) && !(iso === null || iso === void 0 ? void 0 : iso.data) && !(aperture === null || aperture === void 0 ? void 0 : aperture.data) && !(exposureTime === null || exposureTime === void 0 ? void 0 : exposureTime.data) && !(focalLength === null || focalLength === void 0 ? void 0 : focalLength.data) && !(dateTaken === null || dateTaken === void 0 ? void 0 : dateTaken.data)) {
        return null;
    }
    const title = getCameraSectionTitle({
        makeMetadata: cameraMake,
        modelMetadata: cameraModel
    });
    const formattedDateTaken = (dateTaken === null || dateTaken === void 0 ? void 0 : dateTaken.data) ? formatMetadataDate(dateTaken, MONTH_DAY_YEAR_FORMAT) : null;
    return /*#__PURE__*/ _jsxs(InfoPanelDetailsSection, {
        Icon: Camera,
        title: "Camera",
        children: [
            /*#__PURE__*/ _jsx(InfoPanelDetailTitle, {
                children: title
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-1 flex flex-wrap [&>div]:mb-1 [&>div]:basis-1/2",
                children: [
                    !!(iso === null || iso === void 0 ? void 0 : iso.data) && isNumberMetadataType(iso) && /*#__PURE__*/ _jsx(InfoPanelCameraDetailsItem, {
                        text: iso.data,
                        Icon: Iso,
                        label: "ISO"
                    }),
                    !!(aperture === null || aperture === void 0 ? void 0 : aperture.data) && isNumberMetadataType(aperture) && /*#__PURE__*/ _jsx(InfoPanelCameraDetailsItem, {
                        text: "ƒ/".concat(aperture.data),
                        Icon: Aperture,
                        label: "Aperture"
                    }),
                    !!(exposureTime === null || exposureTime === void 0 ? void 0 : exposureTime.data) && isStringMetadataType(exposureTime) && /*#__PURE__*/ _jsx(InfoPanelCameraDetailsItem, {
                        text: exposureTime.data,
                        Icon: Timer,
                        label: "Exposure Time"
                    }),
                    !!(focalLength === null || focalLength === void 0 ? void 0 : focalLength.data) && isStringMetadataType(focalLength) && /*#__PURE__*/ _jsx(InfoPanelCameraDetailsItem, {
                        text: focalLength.data,
                        Icon: FocalLength,
                        label: "Focal Length"
                    })
                ]
            }),
            !!formattedDateTaken && /*#__PURE__*/ _jsx(InfoPanelCameraDetailsItem, {
                text: formattedDateTaken,
                Icon: Calendar,
                label: "Date Taken"
            })
        ]
    });
});
InfoPanelCameraDetails.displayName = "InfoPanelCameraDetails";
